import { useCallback } from 'react';
import { useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated';
import { springs } from '../theme/motion';
import { useReducedMotion } from './useReducedMotion';

interface UseSpringPressOptions {
  pressedScale?: number;
  config?: { damping: number; stiffness: number; mass: number };
}

export function useSpringPress(options: UseSpringPressOptions = {}) {
  const { pressedScale = 0.95, config = springs.press } = options;
  const reduced = useReducedMotion();
  const scale = useSharedValue(1);

  const onPressIn = useCallback(() => {
    if (reduced) return;
    scale.value = withSpring(pressedScale, config);
  }, [reduced, pressedScale, config, scale]);

  const onPressOut = useCallback(() => {
    if (reduced) {
      scale.value = 1;
      return;
    }
    scale.value = withSpring(1, config);
  }, [reduced, config, scale]);

  const style = useAnimatedStyle(() => ({
    transform: [{ scale: scale.value }],
  }));

  return { style, onPressIn, onPressOut };
}
